﻿import type { Tag } from '@/types'
import axios from 'axios'

const path = `${import.meta.env.VITE_CONTENT_API}/tags`
export async function getAllTags() {
    const { data } = await axios.get<Tag[]>(`${path}`)
    return data
}
